module.exports = "img.imageCenter {\r\n    position: relative;\r\n    margin: auto;\r\n}\r\n\r\nimg.imageCenter.loading {\r\n    margin-top: 10px;\r\n}\r\n\r\nimg[hidden] {\r\n    display: none !important;\r\n}\r\n\r\ndiv.imageCenter {\r\n    height: 206px;\r\n    overflow: auto;\r\n    cursor:pointer;\r\n}\r\n\r\n#LinktreeViewBannerItems {\r\n    width: 80%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/banner/banner.component.css
// module id = ./src/app/admin/banner/banner.component.css
// module chunks = main